module.exports = __webpack_public_path__ + "img/share.be237724.svg";